import React, { useEffect } from 'react'
import CasestudyBanner from '../components/Casestudy/CasestudyBanner'
import CasestudyAll from '../components/Casestudy/CasestudyAll'
const CaseStudyPage = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);
    return (
        <div>
            <CasestudyBanner />
            <CasestudyAll />
        </div>
    )
}

export default CaseStudyPage
